import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

const OrganizationManagementCreateOrganizationDialog = (props) => {
  const [newOrganization, setNewOrganization] = useState({});
  const [message, setMessage] = useState({});
  const [createTimeout, setCreateTimeout] = useState({});

  const createOrganization = () => {
    newOrganization.parent = props.organizationId;
    props.createOrganization(newOrganization).then((rv) => {
      clearTimeout(createTimeout);

      if (rv.status === 0) {
        setNewOrganization({ name: "" });
        setMessage({ content: "Organization created successfully" });
        setCreateTimeout(
          setTimeout(() => {
            setMessage({});
            props.handleClose(true)();
          }, 1000)
        );
      } else {
        // error
        setMessage({
          content: `ERROR: ${
            rv.error || "Something went wrong with your request"
          }; please try again or contact support`,
          severity: "error",
        });
      }
    });
  };

  return (
    <Dialog
      open={props.isOpen}
      onClose={props.handleClose(false)}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Create Sub Organization</DialogTitle>
      <DialogContent>
        <Grid
          container
          direction="column"
          wrap="nowrap"
          style={{ height: "100%", padding: 12 }}
        >
          <Grid item style={{ overflowY: "auto", paddingTop: 12 }}>
            <TextField
              variant="standard"
              autoFocus
              inputRef={props.textFieldRef}
              id={"neworg-name"}
              label="Name"
              margin="normal"
              style={{ margin: 0, width: "100%" }}
              value={newOrganization.name}
              onChange={(event) => {
                setNewOrganization({
                  ...newOrganization,
                  ...{ name: event.target.value },
                });
              }} />
          </Grid>
          <Grid item>
            <Grid container direction="row" wrap="nowrap">
              <Grid item xs={9}>
                <Typography variant="body2" color={message.severity}>
                  {message.content}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose(false)} color="primary">
          Cancel
        </Button>
        <Button
          disabled={newOrganization.name === ""}
          onClick={createOrganization}
          color="primary"
        >
          Create Org
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OrganizationManagementCreateOrganizationDialog;
